import { type SuretyAccountId, type SuretyIndemnityAgreementId } from "@inrev/common";

export const accountAttachmentsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "attachments"] as const;

export const accountBondingLineQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "bonding-lines"] as const;

// Temporary: separate from accountBondingLineQueryKey until the whole portal reads the per-type body (DEV-4290).
export const accountBondingLinesBySuretyTypeQueryKey = (accountId: SuretyAccountId) =>
	[...accountBondingLineQueryKey(accountId), "by-surety-type"] as const;

export const accountCompaniesQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "companies"] as const;

export const accountCompanyCheckQueryKey = () => ["accountCreation", "checkCompany"] as const;

export const accountExposureQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "exposure"] as const;

export const projectedAccountExposureQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "exposure", "projected"] as const;

export const accountIndemnityAgreementDownloadQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "indemnity-agreements", "download"] as const;

export const accountIndemnityAgreementsQueryKey = (
	accountId: SuretyAccountId,
	indemnityAgreementId?: SuretyIndemnityAgreementId,
) =>
	indemnityAgreementId
		? (["accounts", accountId, "indemnity-agreements", indemnityAgreementId] as const)
		: (["accounts", accountId, "indemnity-agreements"] as const);

export const accountIndividualsQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "individuals"] as const;

export const accountLatestIndemnityAgreementQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "indemnity-agreements", "latest"] as const;

export const accountLatestUnderwritingQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "underwritings", "latest"] as const;

export const accountMetadataQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "metadata"] as const;

export const accountLatestWipStatementQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "work-in-progress-statements", "latest"] as const;

export const accountNaicsCodesQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "naics-codes"] as const;

export const accountQueryKey = (accountId: SuretyAccountId) => ["accounts", accountId] as const;

export const accountsQueryKey = () => ["accounts"] as const;

export const adminReunderwriteAccountDraftQueryKey = (accountId: SuretyAccountId) =>
	["AdminReUnderwriteSuretyAccountDraft", accountId] as const;

export const contractSuretyCarriersQueryKey = () => ["contractSuretyCarriers"] as const;

export const financialStatementsListQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "financial-statements"] as const;

export const wipQueryKey = (accountId: SuretyAccountId) =>
	["accounts", accountId, "work-in-progress-statements"] as const;
